export default __webpack_public_path__ + "static/media/compas_create_funding.310b6f6c.gif";